import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import styles from "./styles.module.scss";
import AllCoachesPrivateSession from "../AllCoachesPrivateSession";
import useBookSessionData from "../hooks/useBookSessionData";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { Loading } from "app/components/Wrappers";

const SessionAvailability = () => {
  const userID = useSelector((state: RootState) => state.user.self.id);

  const fetcher = useCallback(() => {
    if (!userID) {
      return Promise.resolve([]);
    }
    const facilitiesPromise = schedulingFetchGet("/facilities");
    const coachPromise = schedulingFetchGet("/coach_profiles");

    return Promise.all([facilitiesPromise, coachPromise]);
  }, [userID]);

  const [loadingBookLessonData, bookLessonData] = useBookSessionData(fetcher);

  if (loadingBookLessonData || bookLessonData?.["coaches"]?.[0]?.length === 0) {
    return <Loading isLoading loadType="spinner" />;
  }

  return (
    <div className={styles.container}>
      <AllCoachesPrivateSession bookLessonData={bookLessonData} />
    </div>
  );
};

export default SessionAvailability;
